import React, { useContext, useState } from 'react';
import { User } from '../types/ViewModel/User';

type AuthContextType = {
    loggedInUser: User | null;
    setLoggedInUser: (user: User | null) => void;
    isAuthenticating: boolean;
    setIsAuthenticating: (isAuthenticating: boolean) => void;
    isVerifyingToken: boolean;
    setIsVerifyingToken: (isVerifyingToken: boolean) => void;
    token: string;
    setToken: (token: string) => void;
    userIsUpdated: boolean;
    setUserIsUpdated: (isUpdated: boolean) => void;
    roles: string[];
    setRoles: (roles: string[]) => void;
    canEdit: boolean;
    setCanEdit: (canEdit: boolean) => void;
    canEditChemGuard: boolean;
    setCanEditChemGuard: (canEditChemGuard: boolean) => void;
    canAudit: boolean;
    setCanAudit: (canAudit: boolean) => void;
};

export const AuthContext = React.createContext<AuthContextType>(undefined!);

interface AuthContextProviderProps {
    children: React.ReactNode;
}

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
    const [loggedInUser, setLoggedInUser] = useState<User | null>(null);
    const [isAuthenticating, setIsAuthenticating] = useState<boolean>(false);
    const [isVerifyingToken, setIsVerifyingToken] = useState<boolean>(true); // Start as true like OrcaWebsite
    const [token, setToken] = useState<string>('');
    const [userIsUpdated, setUserIsUpdated] = useState<boolean>(false);
    const [roles, setRoles] = useState<string[]>([]);
    const [canEdit, setCanEdit] = useState<boolean>(false);
    const [canEditChemGuard, setCanEditChemGuard] = useState<boolean>(false);
    const [canAudit, setCanAudit] = useState<boolean>(false);

    return (
        <AuthContext.Provider
            value={{
                loggedInUser,
                setLoggedInUser,
                isAuthenticating,
                setIsAuthenticating,
                isVerifyingToken,
                setIsVerifyingToken,
                token,
                setToken,
                userIsUpdated,
                setUserIsUpdated,
                roles,
                setRoles,
                canEdit,
                setCanEdit,
                canEditChemGuard,
                setCanEditChemGuard,
                canAudit,
                setCanAudit,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthStore = () => useContext(AuthContext);
